/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  WEBAPI_URL: 'https://scelections.aub.edu.lb/api',
  AUTHTOKEN: 'auth_token',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts